import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../components/indexComponents/topHeader.vue'

Vue.use(VueRouter)

  const routes = [

    {
    path: '/',
    name: 'Home',
    component: () => import('../views/indexPage.vue'),
    redirect:'/index',
    children: [
      {
        path: 'index',
        name: 'index',
        meta:{
          selectKey:'index',
        },
        component: () => import('../views/page/index.vue')
      },
      {
        path: 'bugList',
        name: 'bugList',
        meta:{
          selectKey:'bugList',
        },
        component: () => import('../views/page/bugList.vue')
      },
      {
        path: 'bugInfo',
        name: 'bugInfo',
        meta:{
          selectKey:'bugList',
        },
        component: () => import('../views/page/bugInfo.vue')
      },
      {
        path: 'bugEcharts',
        name: 'bugEcharts',
        meta:{
          selectKey:'bugEcharts',
        },
        component: () => import('../views/page/bugEcharts.vue')
      },
      {
        path: 'hotMsg',
        name: 'hotMsg',
        meta:{
          selectKey:'hotMsg',
        },
        component: () => import('../views/page/hotMsg.vue')
      },
      {
        path: 'hotInfo',
        name: 'hotInfo',
        meta:{
          selectKey:'hotMsg',
        },
        component: () => import('../views/page/hotInfo.vue')
      },
      {
        path: 'notice',
        name: 'notice',
        meta:{
          selectKey:'notice',
        },
        component: () => import('../views/page/noticePage.vue')
      },
      {
        path: 'noticeInfo',
        name: 'noticeInfo',
        meta:{
          selectKey:'notice',
        },
        component: () => import('../views/page/noticeInfo.vue')
      },
      {
        path: 'present',
        name: 'present',
        meta:{
          selectKey:'present',
        },
        component: () => import('../views/page/presentationPage.vue')
      },
      {
        path: 'presentInfo',
        name: 'presentInfo',
        meta:{
          selectKey:'present',
        },
        component: () => import('../views/page/presentInfo.vue')
      },
    ]
  },
    {
      path: '/phoneIndex',
      name: 'phoneIndex',
      component: () => import('../views/phone/indexPhone.vue'),
      redirect:'/homePhone',
      children: [
        {
          path: '/homePhone',
          name: 'homePhone',
          meta:{
            num:0
          },
          component: () => import('../views/phone/homePage.vue')
        },
        {
          path: '/bugListphone',
          name: 'bugListphone',
          meta:{
            num:1
          },
          component: () => import('../views/phone/bugListphone.vue')
        },
        {
          path: '/bugInfoPhone',
          name: 'bugInfoPhone',
          component: () => import('../views/phone/hotBug.vue')
        },
        {
          path: '/focus',
          name: 'focus',
          meta:{
            num:2
          },
          component: () => import('../views/phone/focusPage.vue')
        },
        {
          path: '/focusInfo',
          name: 'focusInfo',
          component: () => import('../views/phone/focusInfo.vue')
        },
        // {
        //   path: '/researchReport',
        //   name: 'researchReport',
        //   meta:{
        //     num:3
        //   },
        //   component: () => import('../views/phone/researchReport.vue')
        // },
        // {
        //   path: '/reportInfo',
        //   name: 'reportInfo',
        //   component: () => import('../views/phone/reportInfo.vue')
        // },
        {
          path: '/noticePhone',
          name: 'noticePhone',
          meta:{
            num:3
          },
          component: () => import('../views/phone/noticePhone.vue')
        },
        {
          path: '/noticeInfoPhone',
          name: 'noticeInfoPhone',
          component: () => import('../views/phone/noticeInfoPhone.vue')
        },
        {
          path: '/bugEchartsPhone',
          name: 'bugEchartsPhone',
          meta:{
            num:4
          },
          component: () => import('../views/phone/bugEchartsPhone.vue')
        },
      ]
    },
]

const router = new VueRouter({
  mode:'history',
  routes
})

export default router
